import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import type { ConfirmType } from '@/types/common.types';

interface ConfirmModalProps {
  title: string;
  message: string;
  confirmText: string;
  cancelText?: string;
  type?: ConfirmType;
  onConfirm: () => void;
  onClose: () => void;
}

const ICON_MAP: Record<ConfirmType, string> = {
  danger:  'fa-trash-alt',
  warning: 'fa-exclamation-triangle',
  info:    'fa-question-circle',
};

export function ConfirmModal({
  title,
  message,
  confirmText,
  cancelText,
  type = 'danger',
  onConfirm,
  onClose,
}: ConfirmModalProps) {
  const { t } = useTranslation();

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal-backdrop" onClick={onClose} />
      <div className="confirm-modal-card">
        <div className={`confirm-modal-icon ${type}`}>
          <i className={`fas ${ICON_MAP[type]}`} aria-hidden="true" />
        </div>
        <h3 className="confirm-modal-title">{title}</h3>
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-actions">
          <button className="btn-confirm-cancel" onClick={onClose}>
            {cancelText ?? t('common.cancel')}
          </button>
          <button
            className={`btn-confirm-accept ${type}`}
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
